module.exports = __webpack_public_path__ + "img/ATELIERS.74a24721.svg";